module.exports = __webpack_public_path__ + "static/media/ravencoin-rvn-logo.f11374b2.jpg";